import(/* webpackMode: "eager" */ "/opt/build/repo/components/devlink/index.js")